import React from 'react';

export function MaintenancePage() {

    return (
        <div>
            <div className="text-center justify-content-center border-bottom padding-15">
                <div>
                    <h2>BALLOT REGISTRATION</h2>
                    <h2>抽籤登記</h2>
                </div>
            </div>
            <p className="text-center">
                Server is under maintenance, please try again later.<br />
                We apologise for any inconvenience caused.
            </p>
            <p className="text-center">
                系統正在維護，請稍後重試。不便之處，敬請原諒。
            </p>
            <p className="text-center">
                For any enquiry, please contact us at event-registration@sportshouse.com.hk
            </p>
            <p className="text-center">
                如有查詢，請電郵至 event-registration@sportshouse.com.hk
            </p>
        </div>
    );
}
